import React from 'react';
import { Field } from 'redux-form';
import styles from './style.css';

const Search = props => {
  const { onChange } = props;
  return (
    <div className={`row ${styles.wrapper}`}>
      <div className="col-md-12">
        <div className="right-inner-addon">
          <i className={`fa fa-search ${styles.right}`} />
          <Field
            component="input"
            name="keyword"
            className="form-control"
            placeholder="search"
            onChange={onChange}
          />
        </div>
      </div>
    </div>
  );
};

export default Search;
